import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a41c1e92"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ins-banner" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "txt padding" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "bread padding" }
const _hoisted_6 = { class: "bd" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("首页")
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "产品", -1))
const _hoisted_9 = { class: "prod padding" }
const _hoisted_10 = { class: "txt" }
const _hoisted_11 = { class: "desc" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "产品详情", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cir" }, [
  /*#__PURE__*/_createElementVNode("i")
], -1))
const _hoisted_14 = { class: "img" }
const _hoisted_15 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        src: _ctx.banner.banner,
        alt: "",
        class: "img"
      }, null, 8, _hoisted_2),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h5", null, _toDisplayString(_ctx.banner.name), 1),
        _createElementVNode("h3", {
          innerHTML: _ctx.banner.text
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }),
          _hoisted_8
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.List, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "item gd",
          key: item.id
        }, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("h6", null, _toDisplayString(item.title), 1),
            _createElementVNode("div", _hoisted_11, _toDisplayString(item.brief), 1),
            _createVNode(_component_router_link, {
              to: { path: '/product-detail/' + item.id },
              class: "more gd"
            }, {
              default: _withCtx(() => [
                _hoisted_12,
                _hoisted_13
              ]),
              _: 2
            }, 1032, ["to"])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("img", {
              src: item.image,
              alt: ""
            }, null, 8, _hoisted_15)
          ])
        ]))
      }), 128))
    ]),
    _createVNode(_component_Footer)
  ], 64))
}